<template>
    <div class="campaign-intro typo">
        <component :is="headerTag" :class="[headerClass]">
            Rób zakupy w MAKRO z Aplikacją Mobilną, bo to same korzyści:
        </component>
        <ul class="home">
            <li>
                <img src="@/assets/images/icons/icon_basket.svg" alt=" " />
                Możliwość zakupów w 29 lokalizacjach hal w największych miastach.
            </li>
            <li>
                <img src="@/assets/images/icons/icon_percent.svg" alt=" " />
                Wyjątkowe kupony rabatowe tylko dla użytkowników aplikacji.
            </li>
            <li>
                <img src="@/assets/images/icons/icon_suprise.svg" alt=" " />
                Akcje z nagrodami.
            </li>
            <li>
                <img src="@/assets/images/icons/icon_news.svg" alt=" " />
                Aktualne gazetki promocyjne.
            </li>
            <li>
                <img src="@/assets/images/icons/icon_card.svg" alt=" " />
                Karta do MAKRO zawsze pod ręką.
            </li>
            <li>
                <img src="@/assets/images/icons/icon_scan.svg" alt=" " />
                Łatwe skanowanie i wyszukiwanie produktów.
            </li>
            <li>
                <img src="@/assets/images/icons/icon_pin.svg" alt=" " />
                Mapa z lokalizacją hal i nawigacją dojazdu.
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "CampaignIntro",
        props: {
            headerTag: {
                type: String,
                default: 'h1'
            },
            headerClass: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style lang="scss">
.campaign-intro {
    @import "src/assets/scss/_variables/screen";
    ul.home {
        list-style: none;
        margin: 0;
        padding: 0;
        li {
            padding: 0;
            display: flex;
            margin: 0 0 30px;
            align-items: center;

            img {
                margin-right: 1em;
            }
        }
    }
    @media (max-width: $screen-small-tablet) {

        h1, h2 {
            text-align: center;
        }
        ul.home {
            padding: 0 40px;

            li {
                font-size: 1.2rem;
                img {
                    width: 35px;
                }
            }
        }

    }
    @media (max-width: $screen-small-tablet) {

        ul.home {
            padding: 0;
        }

    }

}
</style>
